import { Link } from "react-router-dom";
import UIcon from "@/assets/uicons/UIcon";
import projectsStyles from '../../styles/projects.module.scss';
import { useI18n } from "../../../i18n/useI18n";
import Button from "@/components/UI/Button/Button";

interface IProjectsHeader {
  onCreateProject: () => void;
}

export const ProjectsHeader = ({ onCreateProject }: IProjectsHeader) => {
  const { t } = useI18n();

  return (
    <div className={projectsStyles.asana_header}>
      {/* Breadcrumb y título principal */}
      <div className={projectsStyles.asana_header__breadcrumb}>
        <div className={projectsStyles.asana_header__breadcrumb_item}>
          <UIcon name="home" size={16} />
          <span>Home</span>
        </div>
        <UIcon name="chevronRight" size={16} className={projectsStyles.asana_header__breadcrumb_separator} />
        <div className={projectsStyles.asana_header__breadcrumb_item}>
          <span>{t("module_projects.module_title")}</span>
        </div>
      </div>

      {/* Título principal y descripción */}
      <div className={projectsStyles.asana_header__title_section}>
        <h1 className={projectsStyles.asana_header__title}>
          {t("module_projects.module_title")}
        </h1>
        <p className={projectsStyles.asana_header__subtitle}>
          Gestiona y organiza todos tus proyectos en un solo lugar
        </p>
      </div>

      {/* Acciones principales */}
      <div className={projectsStyles.asana_header__actions}>
        <Link 
          className={projectsStyles.asana_header__secondary_button}
          to="/assingment"
        >
          <UIcon name="tasks" size={16} />
          {t("home_page.button_show_tasks")}
        </Link>
        <Button variant="primary" onClick={onCreateProject}>
          <UIcon name="add" size={16} />
          Crear Proyecto
        </Button>
      </div>
    </div>
  )
}
